import {
    MessageCircle,
    Mail,
    Phone,
    MapPin,
    Linkedin,
    Instagram,
} from "lucide-react";
import { Link } from "react-router-dom";

const NAV = [
    { label: "Início", href: "#hero" },
    { label: "Soluções", href: "#solucao" },
    { label: "Benefícios", href: "#beneficios" },
    { label: "FAQ", href: "#faq" },
    { label: "Contato", href: "#contato" },
];

export const Footer = () => {
    return (
        <footer
            data-testid="site-footer"
            className="bg-buzas-navy text-white"
        >
            <div className="container-buzas py-16 grid md:grid-cols-2 lg:grid-cols-4 gap-10">
                <div className="lg:col-span-1">
                    <a
                        href="#hero"
                        data-testid="footer-logo"
                        className="inline-flex items-center"
                    >
                        <img
                            src="https://customer-assets.emergentagent.com/job_pecas-sob-medida/artifacts/kadtxnhd_LOGO%20NEGATIVA%20V2.png"
                            alt="Buzas Laser Service"
                            className="h-14 w-auto object-contain"
                        />
                    </a>
                    <p className="mt-5 text-sm text-white/70 leading-relaxed max-w-sm">
                        Soluções industriais sob medida para o agronegócio.
                        Corte a laser, dobra, soldagem e usinagem com suporte
                        técnico especializado.
                    </p>
                </div>

                <div>
                    <p className="text-[11px] font-bold tracking-[0.22em] uppercase text-white/60">
                        Navegação
                    </p>
                    <ul className="mt-4 space-y-2">
                        {NAV.map((n) => (
                            <li key={n.href}>
                                <a
                                    href={n.href}
                                    data-testid={`footer-nav-${n.label
                                        .toLowerCase()
                                        .replace(/[^a-z0-9]/g, "-")}`}
                                    className="text-sm font-semibold text-white/80 hover:text-white transition-colors"
                                >
                                    {n.label}
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>

                <div>
                    <p className="text-[11px] font-bold tracking-[0.22em] uppercase text-white/60">
                        Contato
                    </p>
                    <ul className="mt-4 space-y-3 text-sm text-white/80">
                        <li className="flex items-start gap-2">
                            <Phone className="h-4 w-4 mt-0.5 text-buzas-red" />
                            <a
                                href="tel:+5511940272123"
                                data-testid="footer-phone"
                                className="hover:text-white transition-colors"
                            >
                                (11) 94027-2123
                            </a>
                        </li>
                        <li className="flex items-start gap-2">
                            <Mail className="h-4 w-4 mt-0.5 text-buzas-red" />
                            <a
                                href="mailto:comercial@buzas.com.br"
                                data-testid="footer-email"
                                className="hover:text-white transition-colors"
                            >
                                comercial@buzas.com.br
                            </a>
                        </li>
                        <li className="flex items-start gap-2">
                            <Linkedin className="h-4 w-4 mt-0.5 text-buzas-red" />
                            <a
                                href="https://www.linkedin.com/company/buzas-industria-e-comercio-ltda/"
                                target="_blank"
                                rel="noreferrer"
                                data-testid="footer-linkedin"
                                className="hover:text-white transition-colors"
                            >
                                LinkedIn
                            </a>
                        </li>
                        <li className="flex items-start gap-2">
                            <Instagram className="h-4 w-4 mt-0.5 text-buzas-red" />
                            <a
                                href="https://www.instagram.com/buzas_laser_service/"
                                target="_blank"
                                rel="noreferrer"
                                data-testid="footer-instagram"
                                className="hover:text-white transition-colors"
                            >
                                @buzas_laser_service
                            </a>
                        </li>
                        <li className="flex items-start gap-2">
                            <MapPin className="h-4 w-4 mt-0.5 text-buzas-red" />
                            <span>Brasil</span>
                        </li>
                    </ul>
                </div>

                <div>
                    <p className="text-[11px] font-bold tracking-[0.22em] uppercase text-white/60">
                        WhatsApp
                    </p>
                    <p className="mt-4 text-sm text-white/70 leading-relaxed">
                        Atendimento comercial e técnico ágil direto pelo
                        WhatsApp.
                    </p>
                    <a
                        href="https://api.whatsapp.com/send?phone=5511940272123&text=Ol%C3%A1%2C%20quero%20falar%20com%20a%20Buzas"
                        target="_blank"
                        rel="noreferrer"
                        data-testid="footer-whatsapp"
                        className="mt-4 inline-flex items-center gap-2 rounded-sm bg-buzas-red px-5 py-3 text-sm font-bold text-white hover:bg-buzas-red-600 transition-colors"
                    >
                        <MessageCircle className="h-4 w-4" />
                        Falar no WhatsApp
                    </a>
                </div>
            </div>

            <div className="border-t border-white/10">
                <div className="container-buzas py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
                    <p className="text-xs text-white/55">
                        © {new Date().getFullYear()} Buzas — Soluções Industriais.
                        Todos os direitos reservados.
                    </p>
                    <Link
                        to="/politica-de-privacidade"
                        data-testid="footer-privacy-policy"
                        className="text-xs font-semibold text-white/70 hover:text-white transition-colors"
                    >
                        Política de Privacidade
                    </Link>
                    <p className="text-xs text-white/45">
                        Peças sob medida para máquinas agrícolas · Metalurgia ·
                        Agro
                    </p>
                </div>
            </div>
        </footer>
    );
};
